import type { TOC } from '@ember/component/template-only';
import PageError from '../components/page-error.gts';

interface Signature {
  Args: {};
}

const SearchError: TOC<Signature> = <template>
  <PageError @title="Search failed" @backRoute="index" />
</template>;

export default SearchError;
